/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable sonarjs/no-identical-functions */
import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";
import { ClearButton } from "react-bootstrap-typeahead";

import AutocompleteStyles from "../styles/components/AutocompleteStyles";
import { StyledSelectTeacherDiv } from "../styles/pages/AcademicActivityPlanStyles";

type Option = string | Record<string, any>;

interface AutocompleteProps {
    label?: string;
    onChange?: (selected: Option[]) => void;
    options: Option[];
    placeholder?: string;
    selected?: Option[];
    extraOptions?: boolean;
    style?: CSSProperties;
    customClearFunction?: () => void;
    customOnPaginate?: () => void;
}

function Autocomplete({
    label,
    onChange,
    options,
    placeholder,
    selected,
    extraOptions,
    style,
    customClearFunction,
    customOnPaginate,
}: AutocompleteProps) {
    const { StyledLabel, StyledFormSelect } = AutocompleteStyles;

    const styleGroup: CSSProperties = {
        width: "100%",
        maxWidth: "735px",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];

    return (
        <FormGroup style={style ?? styleGroup}>
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            <StyledFormSelect
                id="basic-example"
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                selected={selected}
                clearButton
                paginationText="Mais resultados"
                onPaginate={() => customOnPaginate && customOnPaginate()}
                paginate
                emptyLabel="Nenhum resultado encontrado"
                filterBy={filterByFields}
                renderMenuItemChildren={(option: any) => (
                    <div>
                        {option?.label}
                        {extraOptions ? (
                            <div>
                                <small>matricula: {option.value}</small>
                            </div>
                        ) : null}
                    </div>
                )}
                className="autocomplete"
            >
                {({ onClear, selected }) => (
                    <div className="rbt-aux">
                        {!!selected.length && (
                            <ClearButton
                                onClick={() =>
                                    customClearFunction
                                        ? customClearFunction()
                                        : onClear()
                                }
                            />
                        )}
                    </div>
                )}
            </StyledFormSelect>
        </FormGroup>
    );
}

export function AutocompleteCombo({
    label,
    onChange,
    options,
    placeholder,
    selected,
    extraOptions,
    style,
    customClearFunction,
    customOnPaginate,
}: AutocompleteProps) {
    const {
        StyledFormCombo,
        StyledLabel,
        StyledFormGroup,
        StyledFormComboEmpty,
    } = AutocompleteStyles;

    const styleGroup: CSSProperties = {
        width: "100%",
        maxWidth: "735px",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];

    return selected?.length ? (
        <StyledFormGroup style={style ?? styleGroup}>
            {label ? <StyledLabel>{label}</StyledLabel> : null}
            <StyledFormCombo
                id="basic-example"
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                selected={selected}
                clearButton
                paginationText="Mais resultados"
                emptyLabel="Nenhum resultado encontrado"
                filterBy={filterByFields}
                renderMenuItemChildren={(option: any) => (
                    <div>{option?.label}</div>
                )}
            />
        </StyledFormGroup>
    ) : (
        <StyledSelectTeacherDiv>
            <div className="selectTeacher" style={{ display: "flex" }}>
                <StyledFormGroup style={style ?? styleGroup}>
                    <StyledFormComboEmpty
                        id="basic-example"
                        onChange={onChange}
                        options={options}
                        placeholder={placeholder}
                        selected={selected}
                        clearButton
                        paginationText="Mais resultados"
                        emptyLabel="Nenhum resultado encontrado"
                        filterBy={filterByFields}
                        renderMenuItemChildren={(option: any) => (
                            <div>{option?.label}</div>
                        )}
                    />
                </StyledFormGroup>
            </div>
        </StyledSelectTeacherDiv>
    );
}

export default Autocomplete;
